import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Protege las rutas autenticadas. Si no hay sesión, redirige a `login`
 * guardando la URL solicitada en `returnUrl` para retomarla tras autenticarse
 * (necesario para el deep-link del escaneo de QR, ver integración §6.5.12).
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
